const o=({spacing:t})=>({styleOverrides:{root:{paddingTop:t(1),paddingBottom:t(2)}}});export{o as default};
